import React from 'react'
import PageLayout from "./pagelayout"
import {Link} from "react-router-dom"

const NotFoundPage = () => {
    return (
        <PageLayout bgWhite fullWidth>
            <div className="flex-center flex-column" style={{paddingTop: `150px`}}>
                <h1 className="m-b-10" style={{fontSize: `9.5em`}}>404</h1>
                <h3 className="m-t-40">Page not found</h3>
                <Link to="/">Go to home</Link>
                <br />
                <br />
            </div>
        </PageLayout>
    )
}

export default NotFoundPage
